module.exports = __webpack_public_path__ + "static/media/hanukkah.2a3c6a82.svg";